import { FC } from "react";
import { CounterpartiesGrid } from "../counterparties/dataGrid";
import { CompletedCounterpartiesGrid } from "../counterparties/completedGrid";
import { Routes, Route } from "react-router-dom";
import { CounterParty } from "../counterParty";
import { CounterPartySignOff } from "../counterParty/signOff";
import { RequestNewCounterparty } from "../requestNew";
import { MyOnboardingRequests } from "../myRequests";

type Props = {};

export const CounterpartiesRoutes: FC<Props> = () => {
  return (
    <Routes>
      <Route
        path="counterparty/:id/signoff"
        element={<CounterPartySignOff />}
      />
      <Route path="counterparty/:id/*" element={<CounterParty />} />
      <Route path="request-new" element={<RequestNewCounterparty />} />
      <Route path="my-requests" element={<MyOnboardingRequests />} />
      <Route path="completed" element={<CompletedCounterpartiesGrid />} />
      <Route path="/*" element={<CounterpartiesGrid />} />
    </Routes>
  );
};
